import { useApp } from "../lib/store";
import { ListPage } from "../components/ListPage";
import { Badge } from "../components/ui/badge";

export default function Contacts() {
  const { t, plLabel } = useApp();
  const columns = [
    { key: "name", label: t("name"), render: (r) => <span className="font-medium text-[#1B2A4A]">{r.first_name} {r.last_name}</span> },
    { key: "title", label: t("title_field") },
    { key: "department", label: t("department"), picklist: "departments" },
    { key: "buying_role", label: t("buying_role"), render: (r) => r.buying_role ? <Badge variant="outline">{plLabel("buying_roles", r.buying_role)}</Badge> : "–" },
    { key: "account_names", label: t("account"), render: (r) => (r.account_names || []).join(", ") || "–" },
    { key: "email", label: t("email") },
    { key: "phone", label: t("phone") },
    { key: "preferred_language", label: "Lang" },
  ];
  return <ListPage module="contacts" titleKey="contacts" columns={columns}
    listQuery="scope=customer" formProps={{ confirmSave: true, allowDelete: true }} />;
}
